
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.788 9.488l-2.731-2.731a.724.724 0 10-1.024 1.024l1.495 1.495H6.62a.724.724 0 000 1.448h7.907l-1.495 1.495a.724.724 0 001.024 1.024l2.73-2.731a.724.724 0 000-1.024z"}}),_c('path',{attrs:{"d":"M11.448 14.103a.724.724 0 00-.724.725v.724H4.448V4.448h6.276v.724a.724.724 0 001.448 0v-.965A1.206 1.206 0 0010.965 3H4.208A1.207 1.207 0 003 4.207v11.586A1.207 1.207 0 004.207 17h6.759a1.206 1.206 0 001.206-1.207v-.965a.724.724 0 00-.724-.725z"}})])
          )
        }
      }
    